module.exports = __webpack_public_path__ + "static/img/icon_up.cbb7971.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_up.svg
// module id = ew32
// module chunks = 156